module.exports = __webpack_public_path__ + "media/images/partners/pvi-981e38db1638dab8e863206e579b2891.png";